import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ControlUser } from '../model/controlUser';
import { Group } from '../model/group';
import { SearchByMethodDialogComponent } from '../search-by-method-dialog/search-by-method-dialog.component'
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { UserOwnerRel } from '../model/userOwnerRel';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DateHelper } from '../util/dateHelper';
import { environment } from 'src/environments/environment';
import { TimeSlotHelper } from '../util/timeSlotHelper';
import { LoaderDialogComponent } from '../loader-dialog/loader-dialog.component';
import { AppComponent } from '../app.component';
import { StringHelper } from '../util/stringHelper';

@Component({
  selector: 'app-owner-users',
  templateUrl: './owner-users.component.html',
  styleUrls: ['./owner-users.component.css']
})
export class OwnerUsersComponent implements OnInit {

  @ViewChild('userslisttable', { static: true }) table;
  @ViewChild('userslistloader', { static: true }) loader;
  @ViewChild(MatSort) sort: MatSort;

  @Output() selected = new EventEmitter<ControlUser>();
  selectedUser: ControlUser;
  selectedRow: number;

  @Input() hideHeader: boolean;

  usersList: UserOwnerRel[];
  groupNames = new Map();
  dataSource: MatTableDataSource<UserOwnerRel>;

  csvData: string = "";

  usersUpdateStatus: string = "";

  noGroupString = $localize`:@@userslist_no_group:Nessuno`

  canUserUserEdit: boolean = false;

  displayedColumns: string[] = [
    'name',
    'description',
    'groupName',
    'user',
    'modifyUser'
  ];

  ownerUid: string;

  backgroundImage: string = "";
  showBackGroundImage: string[] = ["questura@pilomat.com", "questura1@pilomat.com", "gestore@1control.it", "gestore@pilomat.com"];

  dialogLoading: boolean = true;

  constructor(
    public appComponent: AppComponent,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private overlay: Overlay) {

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

    if (this.isService()) {
      this.ownerUid = this.route.snapshot.paramMap.get('uid');
      if (!this.ownerUid) {
        Log.debug('no ownerUid in url ');
        this.ownerUid = this.userService.meUser.uid;
      }
    } else {
      this.ownerUid = this.userService.meUser.uid;
    }

    this.getUserEmail();
    this.getGroups();
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  isService(): boolean {
    return this.appComponent.isService();
  }

  onKey(event: any) {

    let filterString = event.target.value;

    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }

  filterTable(data: UserOwnerRel, filter: string): boolean {

    if (data.user && data.user.displayName && data.user.displayName.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.user && data.user.email && data.user.email.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.groupName && data.groupName.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.description && data.description.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.name && data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }

  getOwnerUsers() {

    Log.debug("getOwnerUsers");

    this.loader.showLoading();

    const obs = this.userService.getOwnerUsers(this.ownerUid);
    obs.subscribe(data => {


  this.usersList = data;

      for (let i = 0; i < this.usersList.length; i++) {
        Log.debug(this.getGroupNameById(this.usersList[i].groupId));
        this.usersList[i].groupName = this.getGroupNameById(this.usersList[i].groupId);

        if (this.isService()) {
          this.usersList[i].name = StringHelper.censorString(this.usersList[i].name);

          if (this.usersList[i].user) {
            this.usersList[i].user.displayName = StringHelper.censorString(this.usersList[i].user.displayName);
          }
        }
      }

      this.checkPermissions();

      const ds = new MatTableDataSource(this.usersList);
      ds.sortingDataAccessor = (item, property) => {
        if (property === 'date') {
          return item && (item as any).createdAt ? (item as any).createdAt.getTime() : 0;
        }
        const value = item ? (item as any)[property] : null;
        if (value == null) {
          return '';
        }
        if (typeof value === 'string') {
          return value.toLowerCase();
        }
        if (typeof value === 'object' && (value as any).displayName) {
          return (value as any).displayName.toLowerCase();
        }
        return value;
      };

      ds.filterPredicate = this.filterTable;
      ds.sort = this.sort;

      this.table.dataSource = ds;

      setTimeout(() => {
        this.loader.hideLoading();
      }, 250);

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
  }

  async checkPermissions(){
    const isAlias = await this.appComponent.isAlias();
    if(isAlias){
      this.canUserUserEdit = await this.checkAliasPermissions("UserEdit");
    } else{
      this.canUserUserEdit = true;
    }
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }

  getGroups() {
    const obs = this.userService.getOwnerGroups(this.ownerUid);
    obs.subscribe(data => {
      for (let i = 0; i < data.length; i++) {
        this.groupNames.set(data[i].groupId, data[i].name);
      }
      this.getOwnerUsers();
    }, error => {
      this.loader.hideLoading();
      this.loader.showError();
    });
    this.loader.hideLoading();
  }

  getGroupNameById(Id: number) {
    if (Id == 0) {
      return this.noGroupString;
    }
    else {
      return this.groupNames.get(Id);
    }
  }



  addUser() {

    Log.debug('clicked adduser ');

    this.router.navigate(['add-user']);
  }

  onRowClicked(row) {

    Log.debug('clicked user with id ' + row.id);

    // this.selectedRow = row.id;

    // this.selected.emit(row.user);
    // this.selectedUser = row;

    //TO CHECK: previsto un emit utente, usato routing´

    if (this.isService()) {
      this.router.navigate(['add-user/', { uid: row.id, ownerUid: this.ownerUid }]);
    } else {
      this.router.navigate(['add-user/' + row.id]);
    }

    this.cdRef.detectChanges();
  }

  getUserEmail() {
    this.userService.getFirebaseUserObs().subscribe(firebaseUser => {
      this.userService.getMe().subscribe(user => {
        if (this.showBackGroundImage.includes(user.email)) {
          this.backgroundImage = "url('assets/img/Banner_pconnect_Milano_day.jpg')";
        } else {
          this.backgroundImage = "unset"
        }
      }, errorRes => {
        Log.debug("error cannot retrieve user ");
      });
    }, errorRes => {
      Log.debug("error cannot retrieve user ");
    });
  }

  searchByMethod() {
    Log.debug("searchByMethod");

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(SearchByMethodDialogComponent, {
      width: '800px',
      data: {},
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {

      }
    });
  }

  downloadCsv() {
    // $localize`:@@userslist_permissions_export_warning:Download utenti in corso, si prega di non aggiornare la pagina`


    // let snackBarRef = this.snackBar.open($localize`:@@userslist_permissions_export_warning:Download utenti in corso, si prega di non aggiornare la pagina`, $localize`:@@userslist_permissions_export_close_toast:chiudi `, {
    //   duration: 3000
    // });
    let message = $localize`:@@userslist_permissions_export_message:Procedere con il download? Si prega di non aggiornare la pagina durante la procedura`;
    let confirmMessage = $localize`:@@userslist_permissions_export_confirm:Confermo`;
    let cancelMessage = $localize`:@@userslist_permissions_export_cancel:Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        let header = $localize`:@@userslist_permissions_export_in_progress:Download in corso`;
        const loaderDialogRef = this.dialog.open(LoaderDialogComponent, {
          width: "350px",
          data: { header, loading: true },
          scrollStrategy,
        });
    
        this.userService.getUserPermissionsCsv(this.userService.meUser.uid).subscribe(
          (permissionsUrl) => {
            if (permissionsUrl == "") {
              loaderDialogRef.close(); // close loader on error
              setTimeout(() => {
                this.openErrorDialog();
              }, 2000);
            } else {
              // Trigger download
              const filename = $localize`:@@userslist_permissions_export:export permessi`;
              const dwldLink = document.createElement("a");
              const url = permissionsUrl;
              const isSafariBrowser =
                navigator.userAgent.indexOf("Safari") != -1 &&
                navigator.userAgent.indexOf("Chrome") == -1;
              if (isSafariBrowser) {
                dwldLink.setAttribute("target", "_blank");
              }
              dwldLink.setAttribute("href", url);
              dwldLink.setAttribute("download", filename + ".csv");
              dwldLink.style.visibility = "hidden";
              document.body.appendChild(dwldLink);
              dwldLink.click();
              document.body.removeChild(dwldLink);
    
              // Close loader AFTER download is triggered
              loaderDialogRef.close();
            }
          },
          (error) => {
            loaderDialogRef.close(); // close loader on error
            setTimeout(() => {
              this.openErrorDialog();
            }, 2000);
          }
        );
      }
    });
    
  }



  reSaveUsers() {
    Log.debug("this.usersList");
    Log.debug(this.usersList);
    this.resaveUser(0);
  }

  resaveUser(index) {

    this.usersUpdateStatus = 'updating user ' + index + ' out of ' + this.usersList.length;

    Log.debug("\nin resaveUser with index: " + index + "\n");

    let user = this.usersList[index];
    let userOwnerRelToPut: UserOwnerRel = new UserOwnerRel();
    userOwnerRelToPut.name = user.name;
    userOwnerRelToPut.description = user.description;
    userOwnerRelToPut.id = user.id;
    userOwnerRelToPut.groupId = user.groupId;

    this.userService.updateUserOwnerRel(userOwnerRelToPut, user.id).subscribe((response) => {
      setTimeout(() => {
        Log.debug("\nin setTimeout with index: " + index + "\n");

        if (index + 1 < this.usersList.length) {
          this.resaveUser(index + 1);
        } else {
          this.usersUpdateStatus = 'updated all ' + this.usersList.length + ' users';
        }
      }, 30000);
    }, (err) => {
      Log.debug(err);
      Log.debug("updateUserOwnerRel error");
      this.loader.showError();
    });
  }

  isPilomatDev(): boolean {
    if (environment.onecontrol.serverFolder == "pilomatdev") {
      return true;
    } else {
      return false;
    }
  }


  isDayAllowed(dayMask: number, dayOfWeek: number) {
    dayOfWeek = dayOfWeek - 1;

    return (dayMask & (1 << dayOfWeek)) == (1 << dayOfWeek);
  }

  openErrorDialog() {
    let header = $localize`:@@userslist_permissions_export_in_progress:Download in corso`;
    let message = $localize`:@@userslist_permissions_export_error:Si é verificato un errore durante il download, si prega riprovare più tardi`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { header, message },
      scrollStrategy,
    });
  }

}


